import { render, staticRenderFns } from "./slide-pagination.vue?vue&type=template&id=be306e02"
import script from "./slide-pagination.vue?vue&type=script&lang=js"
export * from "./slide-pagination.vue?vue&type=script&lang=js"
import style0 from "./slide-pagination.vue?vue&type=style&index=0&id=be306e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports